import { tail } from 'lodash'
import ActionTypes from '../actions/ActionTypes.js'
import { getStatusValue } from '../trips/TripStatus.js'
import notificationBypass from '../lib/NotificationBypass'
import { getText, setLanguage } from '../lib/text.js'

/**
 * initial state
 */

// @TODO: having secondary effects in reducers is blasphemy

const _documentIsDefined = () => ((typeof document !== "undefined") && document)

// console.log("cookie? " + (_documentIsDefined() ? document.cookie : undefined))

const getCookieLang = () => (
  _documentIsDefined()
    ? document.cookie.replace(/(?:(?:^|.*;\s*)lang\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    : undefined
)

const setCookieLang = lang => {
  if (_documentIsDefined()) { 
    document.cookie = `lang=${lang}; expires=Fri, 31 Dec 9999 23:59:59 GMT`
  }
}

setCookieLang(getCookieLang() || "ch")

const initialState = {
  planTriggers: [],
  planStopTriggers: [],
  prompts: [],
  modalsList: [],

  language: getCookieLang() || "ch",
}

/**
 *
 */

export default function ui(state = initialState, action) {
  if (action.type === ActionTypes.CHANGE_LANGUAGE) {
    // #TODO: having secondary effects in reducers is blasphemy
    setCookieLang(action.payload)
    setLanguage(action.payload)
    notificationBypass.notify(getText("refreshToChangeLang", action.payload))
    return {
      ...state,
      language: action.payload
    }
  }

  // disparar el plan 1 si toca
  if (
    (action.type === ActionTypes.UPDATE_ONE_TRIPS || action.type === ActionTypes.UPDATED_ONE_TRIPS)
    && action.payload && action.payload.status
    && action.currentStatus === getStatusValue("new")
    && (
      action.payload.status === getStatusValue("proposal_sent")
      || action.payload.status === getStatusValue("contract_sent")
    )
  ) {
    return {
      ...state,
      planTriggers: state.planTriggers.concat({
        plan: "plan1",
        trip: action.id
      })
    }
  }

  // parar el plan si ya no hace falta (cuando nos ha enviado la fianza)
  if ((action.type === ActionTypes.UPDATE_ONE_TRIPS || action.type === ActionTypes.UPDATED_ONE_TRIPS)
    && action.payload && action.payload.status
    && action.currentStatus <= getStatusValue("contract_sent")
    && action.payload.status >= getStatusValue("bond_sent")
  ) {
    return {
      ...state,
      planStopTriggers: state.planStopTriggers.concat({
        plan: "plan1",
        trip: action.id
      })
    }
  }

  if (action.type === ActionTypes.PLAN_STOP_HANDLED) {
    return {
      ...state,
      planStopTriggers: state.planStopTriggers
        .filter(x => !(x.plan === action.payload.plan && x.trip === action.payload.trip))
    }
  }

  if (action.type === ActionTypes.PLAN_TRIGGER_REJECTED || action.type === ActionTypes.INITIATE_PLAN)
  {
    return {
      ...state,
      planTriggers: state.planTriggers
        .filter(x => !(x.plan === action.payload.plan && x.trip === action.payload.trip))
    }
  }

  if (action.type === ActionTypes.ADD_PROMPT) {
    return {
      ...state,
      prompts: [
        ...state.prompts,
        action.payload
      ]
    }
  }

  if (action.type === ActionTypes.CLOSE_FIRST_PROMPT) {
    return {
      ...state,
      prompts: tail(state.prompts),
    }
  }
  
    
  if (action.type === ActionTypes.TOGGLE_MODAL) {
    return {
      ...state,
      modalsList: (
        action.value == true
          ? state.modalsList.concat([ action.key ])
          : state.modalsList.filter(x => x != action.key)
      )
    }
  }

  return state
}
